import React, { useContext, useState } from 'react';
import Banner from '../../b2b-common/Banner';
import { Save } from '@mui/icons-material';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import { callAPIWhileSettingState, generateTextField } from '../../b2b-common/helpers';
import { LoginContext } from '../../../App';

import './UserNewPage.css';
import { newUser } from '../../../services/b2b-users-apiService';
import B2BDialog from '../../b2b-common/B2BDialog';

const UserNewPage = () => {

    const { loginData } = useContext(LoginContext);

    const [isDialogOpen, setDialogOpen] = useState(false);
    const [dialogError, setDialogError] = useState(null);

    const blankUserDTO = {
        firstName: '',
        lastName: '',
        password: '',
        phoneNumber: '',
        email: '',
        locale: '',
    }
    const [newUserDTO, setNewUserDTO] = useState(blankUserDTO);

    const handleNewUserChange = (key, value) => {
        setNewUserDTO({ ...newUserDTO, [key]: value });
    };

    const [savingUser, setSavingUser] = useState(false);
    const handleSaveUser = async () => {
        const paramsArray = [
            newUserDTO,
            loginData.accessToken
        ];
        try {
            await callAPIWhileSettingState(newUser, paramsArray,
                setSavingUser, onUserCreated);
        } catch (error) {
            setDialogOpen(true);
            setDialogError('Failed to create user: ' + error.message);
        }
    };

    const onUserCreated = (user) => {
        setNewUserDTO(blankUserDTO);
        setDialogOpen(true);
        setDialogError(null);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setDialogError(null);
    };

    const buttonsConfig = [
        {
            label: 'Save',
            onClick: handleSaveUser,
            isLoading: savingUser,
            variant: 'contained',
            key: '1',
            icon: <Save />,
        },
    ];

    return (
        <div className="new-user-page">
            <Banner message="Users Menu: Add new user" />
            <B2BFormContainer title="New user form" buttonsConfig={buttonsConfig} className="new-user-fields-form">
                {generateTextField("eMail", newUserDTO.email, "user-field-email", false, (e) => handleNewUserChange('email', e.target.value), { required: true })}
                {generateTextField("First Name", newUserDTO.firstName, "user-field", false, (e) => handleNewUserChange('firstName', e.target.value), { required: true })}
                {generateTextField("Last Name", newUserDTO.lastName, "user-field", false, (e) => handleNewUserChange('lastName', e.target.value), { required: true })}
                {generateTextField("Phone", newUserDTO.phoneNumber, "user-field", false, (e) => handleNewUserChange('phoneNumber', e.target.value), { required: false })}
                {generateTextField("Locale", newUserDTO.locale, "user-field", false, (e) => handleNewUserChange('locale', e.target.value), { required: true })}
                {generateTextField("Password", newUserDTO.password, "user-field", false, (e) => handleNewUserChange('password', e.target.value), { required: true, type: 'password' })}
            </B2BFormContainer>
            <B2BDialog
                open={isDialogOpen}
                onClose={handleDialogClose}
                title={dialogError ? 'Error Creating User' : 'User Created'}
            >
                <p>{dialogError || "The user has been created successfully."}</p>
            </B2BDialog>
        </div>
    );
};

export default UserNewPage;